import { ApiUrl } from '@common/enums';

import { easyEstimatorApi } from '../easyEstimatorService';

export interface ZipcodeLocationResponse {
    zipCode: string;
    city: string;
    state: string;
    latitude: number;
    longitude: number;
}

const zipcodeApi = easyEstimatorApi.injectEndpoints({
    endpoints: (builder) => ({
        fetchZipcodeLocation: builder.query<ZipcodeLocationResponse, string>({
            query: (zipCode) => ({
                url: ApiUrl.ZIPCODE_LOCATION,
                method: 'GET',
                params: {
                    zipCode: zipCode,
                },
            }),
        }),
    }),
});

export const { useFetchZipcodeLocationQuery, useLazyFetchZipcodeLocationQuery } = zipcodeApi;
